module.exports = __webpack_public_path__ + "img/9th_military.22ea47eb.webp";